import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { supabase } from '../supabaseClient';
import { getLocalDateString } from '../utils/date';


export const fetchTodayMood = createAsyncThunk(
    'moods/fetchTodayMood',
    async (userId) => {
        const today = getLocalDateString(new Date());
        const { data, error } = await supabase

        .from('moods')
        .select('*')
        .eq('user_id', userId)
        .eq('date', today)
        .single();

        if (error && error.code !== 'PGRST116') throw error;
        return data || null;
    }
);


// export const setTodayMood = createAsyncThunk(
//     'moods/setTodayMood',
//     async ({ userId, mood }) => {
//         const today = getLocalDateString(new Date());

//         if (mood === null) {
//             const { error } = await supabase
//                 .from('moods')
//                 .delete()
//                 .eq('user_id', userId)
//                 .eq('date', today);
//             if (error) throw error;
//             return null;
//         }

//         const { data, error } = await supabase
//             .from('moods')
//             .upsert({ user_id: userId, mood, date: today }, { onConflict: ['user_id', 'date'] })
//             .select()
//             .single();

//         if (error) throw error;
//         return data;
//     }
// );


export const setTodayMood = createAsyncThunk(
    'moods/setTodayMood',
    async ({ userId, mood }, thunkAPI) => {
        const today = getLocalDateString(new Date());

        if (mood === null) {
            const { error } = await supabase
                .from('moods')
                .delete()
                .eq('user_id', userId)
                .eq('date', today);
            if (error) throw error;
        } else {
            const { error } = await supabase
                .from('moods')
                .upsert({ user_id: userId, mood, date: today }, { onConflict: ['user_id', 'date'] });
            if (error) throw error;
        }

        // Обновить moodsByDate для текущего месяца
        const now = new Date();
        await thunkAPI.dispatch(fetchMoodsByMonth({
            userId,
            year: now.getFullYear(),
            month: now.getMonth(),
        }));

        return mood === null ? null : { user_id: userId, mood, date: today };
    }
);

export const fetchMoodsByMonth = createAsyncThunk(
    'moods/fetchMoodsByMonth',
    async ({ userId, year, month }) => {
        const startDate = new Date(year, month, 1);
        const endDate = new Date(year, month + 1, 0);
        
        const { data, error } = await supabase
        .from('moods')
        .select('*')
        .eq('user_id', userId)
        .gte('date', getLocalDateString(startDate))
        .lte('date', getLocalDateString(endDate));

        if (error) throw error;
        return data;
    }
);


// export const setMoodForDate = createAsyncThunk(
//     // 'moods/setMoodForDate',
//     // async ({ userId, date, mood }, thunkAPI) => {
//     //     if (mood === null) {
//     //         await supabase
//     //             .from('moods')
//     //             .delete()
//     //             .eq('user_id', userId)
//     //             .eq('date', date);
//     //     } else {
//     //         await supabase
//     //             .from('moods')
//     //             .upsert([{ user_id: userId, date, mood }]);
//     //     }

//     //     thunkAPI.dispatch(fetchMoodsByMonth({
//     //         userId,
//     //         year: new Date(date).getFullYear(),
//     //         month: new Date(date).getMonth(),
//     //     }));
//     // }
//      'moods/setTodayMood',
//     async ({ userId, mood }, thunkAPI) => {
//         const today = getLocalDateString(new Date());

//         if (mood === null) {
//             const { error } = await supabase
//                 .from('moods')
//                 .delete()
//                 .eq('user_id', userId)
//                 .eq('date', today);
//             if (error) throw error;
//         } else {
//             const { error } = await supabase
//                 .from('moods')
//                 .upsert({ user_id: userId, mood, date: today }, { onConflict: ['user_id', 'date'] });
//             if (error) throw error;
//         }

//         // После изменения настроения — обновить moodsByDate для текущего месяца
//         const now = new Date();
//         await thunkAPI.dispatch(fetchMoodsByMonth({
//             userId,
//             year: now.getFullYear(),
//             month: now.getMonth(),
//         }));

//         // Вернуть новое значение todayMood (можно получить из базы, если нужно)
//         return mood === null ? null : { user_id: userId, mood, date: today };
//     }
// );

export const setMoodForDate = createAsyncThunk(
    'moods/setMoodForDate',
    async ({ userId, date, mood }, thunkAPI) => {
        if (mood === null) {
            const { error } = await supabase
                .from('moods')
                .delete()
                .eq('user_id', userId)
                .eq('date', date);
            if (error) throw error;
        } else {
            const { error } = await supabase
                .from('moods')
                .upsert({ user_id: userId, mood, date }, { onConflict: ['user_id', 'date'] });
            if (error) throw error;
        }

        // Обновить moodsByDate для месяца выбранной даты
        const d = new Date(date);
        await thunkAPI.dispatch(fetchMoodsByMonth({
            userId,
            year: d.getFullYear(),
            month: d.getMonth(),
        }));

        return { user_id: userId, mood, date };
    }
);


const moodsSlice = createSlice({
    name: 'moods',
    initialState: {
        todayMood: null,
        status: 'idle',
        error: null,
        moodsByDate: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchTodayMood.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(fetchTodayMood.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.todayMood = action.payload;
        })
        .addCase(fetchTodayMood.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        })
        .addCase(setTodayMood.fulfilled, (state, action) => {
            state.todayMood = action.payload;
        })
        .addCase(fetchMoodsByMonth.fulfilled, (state, action) => {
            const moodsMap = {};
            action.payload.forEach(entry => {
                moodsMap[entry.date] = entry.mood;
            });
            state.moodsByDate = moodsMap;
        });
    }
});

export default moodsSlice.reducer;
